const baseKey = 'INTERACTION_BASE_DEM_COUNTRY_'

export default {
  "AF":	`${baseKey}AF`, //"Afghanistan"
  "EG":	`${baseKey}EG`, //"Egypt"
  "AL":	`${baseKey}AL`, //"Albania"
  "DZ":	`${baseKey}DZ`, //"Algeria"
  "AD":	`${baseKey}AD`, //"Andorra"
  "AO":	`${baseKey}AO`, //"Angola"
  "AG":	`${baseKey}AG`, //"Antigua and Barbuda"
  "GQ":	`${baseKey}GQ`, //"Equatorial Guinea"
  "AR":	`${baseKey}AR`, //"Argentina"
  "AM":	`${baseKey}AM`, //"Armenia"
  "AZ":	`${baseKey}AZ`, //"Azerbaijan"
  "ET":	`${baseKey}ET`, //"Ethiopia"
  "AU":	`${baseKey}AU`, //"Australia"
  "BS":	`${baseKey}BS`, //"Bahamas"
  "BH":	`${baseKey}BH`, //"Bahrain"
  "BD":	`${baseKey}BD`, //"Bangladesh"
  "BB":	`${baseKey}BB`, //"Barbados"
  "BE":	`${baseKey}BE`, //"Belgium"
  "BZ":	`${baseKey}BZ`, //"Belize"
  "BJ":	`${baseKey}BJ`, //"Benin"
  "BT":	`${baseKey}BT`, //"Bhutan"
  "BO":	`${baseKey}BO`, //"Bolivia"
  "BA":	`${baseKey}BA`, //"Bosnia and Herzegovina"
  "BW":	`${baseKey}BW`, //"Botswana"
  "BR":	`${baseKey}BR`, //"Brazil"
  "BN":	`${baseKey}BN`, //"Brunei"
  "BG":	`${baseKey}BG`, //"Bulgaria"
  "BF":	`${baseKey}BF`, //"Burkina Faso"
  "BI":	`${baseKey}BI`, //"Burundi"
  "CL":	`${baseKey}CL`, //"Chile"
  "CN":	`${baseKey}CN`, //"China"
  "CK":	`${baseKey}CK`, //"Cook Islands"
  "CR":	`${baseKey}CR`, //"Costa Rica"
  "DK":	`${baseKey}DK`, //"Denmark"
  "DE":	`${baseKey}DE`, //"Germany"
  "DM":	`${baseKey}DM`, //"Dominica"
  "DO":	`${baseKey}DO`, //"Dominican Republic"
  "DJ":	`${baseKey}DJ`, //"Djibouti"
  "EC":	`${baseKey}EC`, //"Ecuador"
  "SV":	`${baseKey}SV`, //"El Salvador"
  "CI":	`${baseKey}CI`, //"Ivory Coast"
  "ER":	`${baseKey}ER`, //"Eritrea"
  "EE":	`${baseKey}EE`, //"Estonia"
  "SZ":	`${baseKey}SZ`, //"Eswatini"
  "FJ":	`${baseKey}FJ`, //"Fiji"
  "FI":	`${baseKey}FI`, //"Finland"
  "FR":	`${baseKey}FR`, //"France"
  "GA":	`${baseKey}GA`, //"Gabon"
  "GM":	`${baseKey}GM`, //"Gambia"
  "GE":	`${baseKey}GE`, //"Georgia"
  "GH":	`${baseKey}GH`, //"Ghana"
  "GD":	`${baseKey}GD`, //"Grenada"
  "GR":	`${baseKey}GR`, //"Greece"
  "GT":	`${baseKey}GT`, //"Guatemala"
  "GN":	`${baseKey}GN`, //"Guinea"
  "GW":	`${baseKey}GW`, //"Guinea-Bissau"
  "GY":	`${baseKey}GY`, //"Guyana"
  "HT":	`${baseKey}HT`, //"Haiti"
  "HN":	`${baseKey}HN`, //"Honduras"
  "IN":	`${baseKey}IN`, //"India"
  "ID":	`${baseKey}ID`, //"Indonesia"
  "IQ":	`${baseKey}IQ`, //"Iraq"
  "IR":	`${baseKey}IR`, //"Iran"
  "IE":	`${baseKey}IE`, //"Ireland"
  "IS":	`${baseKey}IS`, //"Iceland"
  "IL":	`${baseKey}IL`, //"Israel"
  "IT":	`${baseKey}IT`, //"Italy"
  "JM":	`${baseKey}JM`, //"Jamaica"
  "JP":	`${baseKey}JP`, //"Japan"
  "YE":	`${baseKey}YE`, //"Yemen"
  "JO":	`${baseKey}JO`, //"Jordan"
  "KH":	`${baseKey}KH`, //"Cambodia"
  "CM":	`${baseKey}CM`, //"Cameroon"
  "CA":	`${baseKey}CA`, //"Canada"
  "CV":	`${baseKey}CV`, //"Cape Verde"
  "KZ":	`${baseKey}KZ`, //"Kazakhstan"
  "QA":	`${baseKey}QA`, //"Qatar"
  "KE":	`${baseKey}KE`, //"Kenya"
  "KG":	`${baseKey}KG`, //"Kyrgyzstan"
  "KI":	`${baseKey}KI`, //"Kiribati"
  "CO":	`${baseKey}CO`, //"Colombia"
  "KM":	`${baseKey}KM`, //"Comoros"
  "CD":	`${baseKey}CD`, //"Congo, Democratic Republic"
  "CG":	`${baseKey}CG`, //"Congo, Republic"
  "XK":	`${baseKey}XK`, //"Kosovo"
  "HR":	`${baseKey}HR`, //"Croatia"
  "CU":	`${baseKey}CU`, //"Cuba"
  "KW":	`${baseKey}KW`, //"Kuwait"
  "LA":	`${baseKey}LA`, //"Lao"
  "LS":	`${baseKey}LS`, //"Lesotho"
  "LV":	`${baseKey}LV`, //"Latvia"
  "LB":	`${baseKey}LB`, //"Lebanon"
  "LR":	`${baseKey}LR`, //"Liberia"
  "LY":	`${baseKey}LY`, //"Libya"
  "LI":	`${baseKey}LI`, //"Liechtenstein"
  "LT":	`${baseKey}LT`, //"Lithuania"
  "LU":	`${baseKey}LU`, //"Luxembourg"
  "MG":	`${baseKey}MG`, //"Madagascar"
  "MW":	`${baseKey}MW`, //"Malawi"
  "MY":	`${baseKey}MY`, //"Malaysia"
  "MV":	`${baseKey}MV`, //"Maldives"
  "ML":	`${baseKey}ML`, //"Mali"
  "MT":	`${baseKey}MT`, //"Malta"
  "MA":	`${baseKey}MA`, //"Morocco"
  "MH":	`${baseKey}MH`, //"Marshall Islands"
  "MR":	`${baseKey}MR`, //"Mauritania"
  "MU":	`${baseKey}MU`, //"Mauritius"
  "MX":	`${baseKey}MX`, //"Mexico"
  "FM":	`${baseKey}FM`, //"Micronesia"
  "MD":	`${baseKey}MD`, //"Moldova"
  "MC":	`${baseKey}MC`, //"Monaco"
  "MN":	`${baseKey}MN`, //"Mongolia"
  "ME":	`${baseKey}ME`, //"Montenegro"
  "MZ":	`${baseKey}MZ`, //"Mozambique"
  "MM":	`${baseKey}MM`, //"Myanmar"
  "NA":	`${baseKey}NA`, //"Namibia"
  "NR":	`${baseKey}NR`, //"Nauru"
  "NP":	`${baseKey}NP`, //"Nepal"
  "NZ":	`${baseKey}NZ`, //"New Zealand"
  "NI":	`${baseKey}NI`, //"Nicaragua"
  "NL":	`${baseKey}NL`, //"Netherlands"
  "NE":	`${baseKey}NE`, //"Niger"
  "NG":	`${baseKey}NG`, //"Nigeria"
  "KP":	`${baseKey}KP`, //"North Korea"
  "MK":	`${baseKey}MK`, //"North Macedonia"
  "NO":	`${baseKey}NO`, //"Norway"
  "OM":	`${baseKey}OM`, //"Oman"
  "AT":	`${baseKey}AT`, //"Austria"
  "TL": `${baseKey}TL`, //"(TP)	East Timor"
  "PK":	`${baseKey}PK`, //"Pakistan"
  "PS":	`${baseKey}PS`, //"Palestine"
  "PW":	`${baseKey}PW`, //"Palau"
  "PA":	`${baseKey}PA`, //"Panama"
  "PG":	`${baseKey}PG`, //"Papua New Guinea"
  "PY":	`${baseKey}PY`, //"Paraguay"
  "PE":	`${baseKey}PE`, //"Peru"
  "PH":	`${baseKey}PH`, //"Philippines"
  "PL":	`${baseKey}PL`, //"Poland"
  "PT":	`${baseKey}PT`, //"Portugal"
  "RW":	`${baseKey}RW`, //"Rwanda"
  "RO":	`${baseKey}RO`, //"Romania"
  "RU":	`${baseKey}RU`, //"Russia"
  "SB":	`${baseKey}SB`, //"Solomon Islands"
  "ZM":	`${baseKey}ZM`, //"Zambia"
  "WS":	`${baseKey}WS`, //"Samoa"
  "SM":	`${baseKey}SM`, //"San Marino"
  "ST":	`${baseKey}ST`, //"São Tomé and Príncipe"
  "SA":	`${baseKey}SA`, //"Saudi Arabia"
  "SE":	`${baseKey}SE`, //"Sweden"
  "CH":	`${baseKey}CH`, //"Switzerland"
  "SN":	`${baseKey}SN`, //"Senegal"
  "RS":	`${baseKey}RS`, //"Serbia"
  "SC":	`${baseKey}SC`, //"Seychelles"
  "SL":	`${baseKey}SL`, //"Sierra Leone"
  "ZW":	`${baseKey}ZW`, //"Zimbabwe"
  "SG":	`${baseKey}SG`, //"Singapore"
  "SK":	`${baseKey}SK`, //"Slovakia"
  "SI":	`${baseKey}SI`, //"Slovenia"
  "SO":	`${baseKey}SO`, //"Somalia"
  "ES":	`${baseKey}ES`, //"Spain"
  "LK":	`${baseKey}LK`, //"Sri Lanka"
  "KN":	`${baseKey}KN`, //"Saint Kitts and Nevis"
  "LC":	`${baseKey}LC`, //"Saint Lucia"
  "VC":	`${baseKey}VC`, //"Saint Vincent and the Grenadines"
  "ZA":	`${baseKey}ZA`, //"South Africa"
  "SD":	`${baseKey}SD`, //"Sudan"
  "KR":	`${baseKey}KR`, //"South Korea"
  "SS":	`${baseKey}SS`, //"South Sudan"
  "SR":	`${baseKey}SR`, //"Suriname"
  "SY":	`${baseKey}SY`, //"Syria"
  "TJ":	`${baseKey}TJ`, //"Tajikistan"
  "TW":	`${baseKey}TW`, //"Taiwan"
  "TZ":	`${baseKey}TZ`, //"Tanzania"
  "TH":	`${baseKey}TH`, //"Thailand"
  "TG":	`${baseKey}TG`, //"Togo"
  "TO":	`${baseKey}TO`, //"Tonga"
  "TT":	`${baseKey}TT`, //"Trinidad and Tobago"
  "TD":	`${baseKey}TD`, //"Chad"
  "CZ":	`${baseKey}CZ`, //"Czech Republic"
  "TN":	`${baseKey}TN`, //"Tunisia"
  "TR":	`${baseKey}TR`, //"Turkey"
  "TM":	`${baseKey}TM`, //"Turkmenistan"
  "TV":	`${baseKey}TV`, //"Tuvalu"
  "UG":	`${baseKey}UG`, //"Uganda"
  "UA":	`${baseKey}UA`, //"Ukraine"
  "HU":	`${baseKey}HU`, //"Hungary"
  "UY":	`${baseKey}UY`, //"Uruguay"
  "UZ":	`${baseKey}UZ`, //"Uzbekistan"
  "VU":	`${baseKey}VU`, //"Vanuatu"
  "VA":	`${baseKey}VA`, //"Vatican City"
  "VE":	`${baseKey}VE`, //"Venezuela"
  "AE":	`${baseKey}AE`, //"United Arab Emirates"
  "US":	`${baseKey}US`, //"United States (USA)"
  "GB":	`${baseKey}GB`, //"United Kingdom (UK)"
  "VN":	`${baseKey}VN`, //"Vietnam"
  "BY":	`${baseKey}BY`, //"Belarus"
  "CF":	`${baseKey}CF`, //"Central African Republic"
  "CY":	`${baseKey}CY`, //"Cyprus"
}